import builder from '../builder';
import Envelope from '../../streamline-icons/light/envelope.svg';

export default builder('IconEnvelopeLight', Envelope);
